import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { useCmsLocaleReload } from '@slg/web-customer-shared';
import VueMarkdown from 'vue-markdown';
import CommuneGroup from '@/components/nightCard/CommuneGroup.vue';
import { getNightCardPage, getCommunes } from '@/services/cmsService';
import { useStore } from '@/composables';


import { getMetaInfo } from '@/utils/seo';

const __default__ = {
  name: 'NightCardPage',
  metaInfo() {
    return getMetaInfo((this as { seo?: unknown }).seo);
  },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();
const title = ref('');
const description = ref('');
const descriptionKey = ref(new Date().toString());
const subTitle = ref('');
const communesList = ref<any[]>([]);
const seo = ref<any>('');

async function getNightCardPageAPI() {
  const data = await getNightCardPage() as any;
  seo.value = data.Seo;
  title.value = data.Title;
  subTitle.value = data.Subtitle;
  description.value = data.Description;
  descriptionKey.value = new Date().toString();
}

async function getNightCardListAPI() {
  communesList.value = await getCommunes() as any;
}

async function loadCmsData() {
  try {
    store.commit('common/setGlobalLoading', true);
    await getNightCardPageAPI();
    await getNightCardListAPI();
  } catch (e) {
    // to-do rethink about catch
  }
  store.commit('common/setGlobalLoading', false);
}

useCmsLocaleReload(loadCmsData);

return { __sfc: true,store, title, description, descriptionKey, subTitle, communesList, seo, getNightCardPageAPI, getNightCardListAPI, loadCmsData, VueMarkdown, CommuneGroup }
}

})